import type { QueryClient } from "@tanstack/react-query";

/** Refresh reading evidence and every consumer of meter-driven PM state after a successful write. */
export async function invalidateMeterReading(client: QueryClient): Promise<void> {
  await Promise.all(
    ["assets", "meters", "schedules", "dashboard", "metrics"].map((family) =>
      client.invalidateQueries({ queryKey: [family] }),
    ),
  );
}
